import React, { type ComponentPropsWithoutRef } from 'react';

import { Card, Separator } from '@betterment/samba-react';

import type { SystemStyleObject } from '@betterment/samba-styled-system/types';

type BaseProps = {
  children: React.ReactNode;
  css?: SystemStyleObject;
};

type LegacyCardProps = BaseProps & ComponentPropsWithoutRef<'div'>;
type LegacyCardHeaderProps = BaseProps & ComponentPropsWithoutRef<'div'>;
type LegacyCardContentProps = BaseProps & ComponentPropsWithoutRef<'div'>;
type LegacyCardFooterProps = BaseProps & ComponentPropsWithoutRef<'div'>;

const LegacyCard = ({ children, css: cssProp, ...props }: LegacyCardProps) => {
  return (
    <Card
      css={{
        borderWidth: 'thin',
        borderStyle: 'solid',
        borderColor: 'border.weak',
        boxShadow: 'none',
        ...cssProp,
      }}
      {...props}
    >
      {children}
    </Card>
  );
};

const Header = ({ children, css: cssProp, ...props }: LegacyCardHeaderProps) => {
  return (
    <Card.Header css={{ padding: 'space.300', ...cssProp }} {...props}>
      {children}
    </Card.Header>
  );
};

const Content = ({ children, css: cssProp, ...props }: LegacyCardContentProps) => {
  return (
    <Card.Content css={{ padding: 'space.300', ...cssProp }} {...props}>
      {children}
    </Card.Content>
  );
};

const Footer = ({ children, css: cssProp, ...props }: LegacyCardFooterProps) => {
  return (
    <Card.Footer css={{ padding: 'space.300', ...cssProp }} {...props}>
      {children}
    </Card.Footer>
  );
};

Header.displayName = 'LegacyCard.Header';
Content.displayName = 'LegacyCard.Content';
Footer.displayName = 'LegacyCard.Footer';

LegacyCard.Header = Header;
LegacyCard.Content = Content;
LegacyCard.Footer = Footer;
LegacyCard.Separator = Separator;
LegacyCard.displayName = 'LegacyCard';

export { LegacyCard };
